export enum LoadSliderInputType {
    n0,
    n1,
    n2,
    n3,
    n4,
    m0,
    m1,
    m2,
    m3,
    m4
}
